import type { IChangelog } from '@/types/changelog'
import type { IComment } from '@/types/comment'
import type { IResourceTypes } from '@/types/common'
import type { IPost } from '@/types/post'
import type { IUserProfile } from '@/types/user'

export const canViewAttachments = (
  resource: IPost | IComment | IChangelog,
  resourceType: IResourceTypes,
  user?: IUserProfile
) => {
  if ('submitter' in resource) {
    return (
      user?.is_csm_of_organization ||
      resource.can_edit ||
      user?.id === resource?.submitter?.id
    )
  }

  if ('commenter' in resource) {
    return (
      user?.is_csm_of_organization ||
      resource.can_edit ||
      user?.id === resource?.commenter?.id
    )
  }

  if (resourceType === 'Changelog') {
    return true
  }

  return !!user?.is_csm_of_organization
}

export const canDeletePostAttachment = (
  resource: IPost | IComment,
  user?: IUserProfile
) => {
  if ('submitter' in resource) {
    return (
      user &&
      (user.is_member_of_organization ||
        resource.can_edit ||
        user.id === resource.submitter?.id)
    )
  }

  return (
    user &&
    (user.is_member_of_organization ||
      resource.can_edit ||
      user.id === resource.commenter?.id)
  )
}

export const canAddAttachments = (
  _resource: IPost | IComment | IChangelog,
  user?: IUserProfile
) => {
  return !!user?.is_csm_of_organization
}
